import React from 'react';
import moment from 'moment';
import _ from 'underscore';
import FilterIcon from 'components/v2/icons/FilterIcon';
import Badge from 'components/v2/Badge';
import { humanize, titleize } from 'underscore.string';
import { getCustomerName } from './helpers';
/*
 * An active filters component
 */
export default function ActiveFilters({ query, onRemove, onClear }) {
    const active = [];
    _.map(query, (value, key) => {
        if (value && value !== undefined) {
            if (key === 'window_start') {
                active.push({
                    code: 1,
                    component: (React.createElement(Badge, { key: 1, withRemove: true, onRemove: () => onRemove('window_start', { window_start: undefined }), color: "blue" }, `Start: ${moment(value).format('MM-DD-YYYY')}`)),
                });
            }
            else if (key === 'window_end') {
                active.push({
                    code: 2,
                    component: (React.createElement(Badge, { key: 2, withRemove: true, onRemove: () => onRemove('window_end', { window_end: undefined }), color: "blue" }, `End: ${moment(value).format('MM-DD-YYYY')}`)),
                });
            }
            else if (key === 'yard') {
                value.forEach((l) => {
                    active.push({
                        code: 10,
                        component: (React.createElement(Badge, { key: 10, withRemove: true, onRemove: () => onRemove('yard_remove', value, l._id), color: "yellow" }, `Yard: ${titleize(l.name)}`)),
                    });
                });
            }
            else if (key === 'status') {
                value.forEach((s) => {
                    active.push({
                        code: 20,
                        component: (React.createElement(Badge, { key: 20, withRemove: true, onRemove: () => onRemove('status_remove', value, s.slug), color: "purple" }, `Status: ${titleize(s.slug)}`)),
                    });
                });
            }
            else if (key === 'container_number') {
                value.forEach((c) => {
                    active.push({
                        code: 25,
                        component: (React.createElement(Badge, { key: 25, withRemove: true, onRemove: () => onRemove('container_remove', value, c), color: "yellow" }, `Container: ${c}`)),
                    });
                });
            }
            else if (key === 'master_bill_number') {
                value.forEach((m) => {
                    active.push({
                        code: 25,
                        component: (React.createElement(Badge, { key: `master_bill_number-${m}`, withRemove: true, onRemove: () => onRemove('master_bill_remove', value, m), color: "yellow" }, `Master Bill: ${m}`)),
                    });
                });
            }
            else if (key === 'consignee') {
                value.forEach((c) => {
                    active.push({
                        code: 30,
                        component: (React.createElement(Badge, { key: `consignee-${c._id}`, withRemove: true, onRemove: () => onRemove('consignee_remove', value, c._id), color: "pink" }, `Consignee: ${titleize(getCustomerName(c))}`)),
                    });
                });
            }
            else if (key === 'shipper') {
                value.forEach((s) => {
                    active.push({
                        code: 40,
                        component: (React.createElement(Badge, { key: `shipper-${s._id}`, withRemove: true, onRemove: () => onRemove('shipper_remove', value, s._id), color: "green" }, `Shipper: ${titleize(getCustomerName(s))}`)),
                    });
                });
            }
            else if (key === 'carrier') {
                value.forEach((c) => {
                    active.push({
                        code: 50,
                        component: (React.createElement(Badge, { key: `carrier-${c._id}`, withRemove: true, onRemove: () => onRemove('carrier_remove', value, c._id), color: "blue" }, `Carrier: ${titleize(getCustomerName(c))}`)),
                    });
                });
            }
            else if (key === 'sortBy') {
                active.push({
                    code: 100,
                    component: (React.createElement(Badge, { key: "sort_by_remove", withRemove: true, onRemove: () => onRemove('sort_by_remove'), color: "red" }, `Sorted By: ${titleize(humanize(value))} ${query.sortOrder.toUpperCase()}`)),
                });
            }
        }
    });
    if (active && active.length > 0) {
        active.push({
            code: 150,
            component: (React.createElement("button", { className: "text-xs text-blue", onClick: onClear, key: "clear-all" }, "[Clear All Filters]")),
        });
    }
    const activeFilters = _.sortBy(active, 'code').map((a) => a.component);
    return (React.createElement("div", { className: "p-4" },
        React.createElement("div", { className: "flex flex-wrap space-x-2 space-y-2" },
            React.createElement(FilterIcon, { className: "mt-1 w-6 h-6 text-green" }),
            React.createElement("label", { className: "form-label" }, "Sorting "),
            activeFilters)));
}
